import Platforms from '../Platforms';
import './style.scss';

const Main = () => {
    return (
        <div className="container">
            <div className="row align-items-center gy-5">
                <div className="col-xl-5 col-lg-6 col-md-6 col-12">
                    <h5 className="sub-header mt-4 mt-sm-0">Get Crypto Good - Without the Risk!</h5>
                    <h2 className="header">Buy, sell & strategize with real crypto data - using virtual money.</h2>
                    <h3 className="header">No risk, just fun!</h3>
                    <a type="button" href="https://play.google.com/store/apps/" className="custom-btn">
                        <img src="./google-play.svg" alt="Google Play" />
                    </a>
                    <a type="button" href="https://apps.apple.com/us/app/cryptogood-trading-simulator/id6743053758" className="custom-btn">
                        <img src='./app-store.svg' alt="App Store" />
                    </a>
                </div>
                <div className="col-xl-7 col-lg-6 col-md-6 col-12 text-end">
                    <div className="main-image">
                        <img src="./main.png" className="img-fluid" alt="Main" />
                    </div>
                </div>
            </div>
            <div className="row align-items-center px-0 sm-px-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                    <Platforms />
                </div>
            </div>
        </div>
    );
};

export default Main;
